export const initialState={
  user:null,
  playlists:[],
  playing: false,
  item:null,
  // REMOVE after finished developing..
  //token: 'BQCTDXn1tNYNbwcHbHmLGFFF_0ARTHWZvapiWoOFV1oFAhX_iKV0s7SHpoQPib0yK2x,'
};

const reducer = (state, action) =>{
 console.log(action);
 switch(action.type){    //actiom -> type,payload
   case 'SET_USER':
     return{
       ...state,
       user: action.user,
     };
     case 'SET_TOKEN':
       return{
         ...state,
         token: action.token,
       };
      
      case "SET_PLAYLISTS":
        return {
          ...state,
          playlists:action.playlists,
        };
      case 'SET_DISCOVER_WEEKLY':
        return{
          ...state,
          discover_weekly: action.discover_weekly,
        }

    default: 
        return state; 
 }
}

export default reducer;
